import script from "./exitTeamDialog.vue?vue&type=script&lang=tsx&setup=true"
export * from "./exitTeamDialog.vue?vue&type=script&lang=tsx&setup=true"

import "./exitTeamDialog.vue?vue&type=style&index=0&id=1f05e0bd&lang=less"

const __exports__ = script;

export default __exports__